export const headerCells = [
  { value: "nid", label: "NID" },
  { value: "direccion", label: "Dirección" },
  { value: "conjunto_edificio", label: "Nombre de Conjunto" },
  { value: "editar", label: "" },
];
